import React,{createContext} from "react";




const AuthContext = createContext({
    ID:"",
    login:()=>{},
    logout: function (){},
    isAuthntificated: false
})

export default AuthContext

